import { FC, useReducer, useContext, useState, useEffect } from "react";
import { LOGIN, LOGOUT, GETPROFILE, GET2FACODE } from "../action";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import AlertContext from "../Alert/AlertContext";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import loginMutation from "../../utils/mutations/onBoardingMutations/loginMutation";
import resendEmail from "../../utils/queries/onBoardingQueries/resendLink";
import forgerMutation from "../../utils/mutations/onBoardingMutations/forgotMutation";
import resetMutation from "../../utils/mutations/onBoardingMutations/resetMutation";
import graphQLClient from "../../utils/authHeader";
import customGraphQLClient from "../../utils/customHeader";
import GET_PROFILE from "../../utils/queries/getProfile";
import REFRESH_TOKEN from "../../utils/queries/refreshToken";
import GET_TWO_FA from "../../utils/queries/twoFA";
import ENABLE_TWOFA from "../../utils/mutations/twoFA/enableTwoFA";
import VERIFY_TWOFA from "../../utils/mutations/twoFA/verifyTwoFA";
import DISABLE_TWOFA from "../../utils/mutations/twoFA/disableTwoFA";
import GOOGLE_LOGIN_MUTATION from "../../utils/mutations/onBoardingMutations/googleLoginMutation";
import { eventBus } from "../../utils/event";

const AuthState: FC = (props) => {
  const history = useHistory();
  const { setAlert } = useContext<any>(AlertContext);
  const [showresetlink, setShowResetLink] = useState(false);
  const user = JSON.parse(localStorage.getItem("user")!);
  const accessToken = JSON.parse(localStorage.getItem("accessToken")!);
  const refreshToken = JSON.parse(localStorage.getItem("refreshToken")!);
  const initialState = user
    ? {
        accessToken: accessToken,
        refreshToken: refreshToken,
        isAuthenticated: true,
        isLoading: false,
        userobj: user,
        getProfileData: null,
        secretToken: "",
        otpAuthUrl: "",
      }
    : {
        accessToken: "",
        refreshToken: "",
        isAuthenticated: false,
        isLoading: false,
        userobj: null,
        getProfileData: null,
        secretToken: "",
        otpAuthUrl: "",
      };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  useEffect(() => {

    const handleLogout = () => {
      Logout(false);
    }

    eventBus.on('logout', handleLogout)


    return () => {
      eventBus.off('logout', handleLogout)
    }
  }, []);


  //send the login dispatch to the reducer
  // TODO: Implmenet this for other methods like 
  // login, verify2FA etc.
  const sendLoginDispatch = (payload?: any) => {
    dispatch({
      type: LOGIN,
      payload,
    });
  }

  //Login
  const Login = (values: any) => {
    Signin();
    async function Signin() {

      if (values.remember === true) {
        localStorage.setItem("rememberemail", values.email.toLowerCase());
      }

      const variables = {
        signInData: {
          email: values.email.toLowerCase(),
          password: values.password,
          captcha: values.captcha,
        },
      };

      customGraphQLClient.request( loginMutation, variables)
        .then((data) => {
          if (data?.signin?.isTwoFaEnabled === true) {
            // check if 2fa enable or not if enable there is second step of verifcation code
            localStorage.setItem("twoFaToken", data?.signin?.twoFaToken);
            history.push("/verification-code");
          } else {
            setAlert("You are logged in", "success");
            graphQLClient.setHeader('authorization', `Bearer ${data?.signin?.accessToken}`);
            dispatch({
              type: LOGIN,
              payload: data?.signin,
            });
          }
        })
        .catch((err) => {
          if (err?.response?.errors) {
            err?.response?.errors?.map((newerro: { message: any }) => {
              setAlert(newerro?.message, "warning");
              history.push("/login");
              return;
            });
          } else {
            setAlert("Something went wrong while attempting to login.", "error");
          }
        });
    }
  };

  // Google Login
  const GoogleLogin = (idToken: string) => {
    const variables = {
      googleSignInData: {
        idToken
      }
    }
    customGraphQLClient
    .request(GOOGLE_LOGIN_MUTATION, variables)
    .then((data: any) => {
      if (data?.googleLogin?.isTwoFaEnabled === true) {
        // check if 2fa enable or not if enable there is second step of verifcation code
        localStorage.setItem("twoFaToken", data?.googleLogin?.twoFaToken);
        history.push("/verification-code");
      } else {
        setAlert("You are logged in", "success");
        graphQLClient.setHeader('authorization', `Bearer ${data?.googleLogin?.accessToken}`);
        dispatch({
          type: LOGIN,
          payload: data?.googleLogin,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.errors) {
        err?.response?.errors?.map((newerro: { message: any }) => {
          setAlert(newerro?.message.substring(0,21) + "...", "warning");
          history.push("/login");
          return;
        });
      } else {
        setAlert("Something went wrong while attempting to login.", "error");
      }
    });
  }

  //signup then confirm email link send
  const SignUpService = (values: any) => {
    // Sign-up is temporarily disabled from the frontend.
    // The registration request is intentionally not sent; the user just sees a generic error.
    // To re-enable, restore the original Signup() flow from git history and remove this early return.
    setAlert("Something went wrong. Please try again later.", "error");
    return;
  };

  //if user not recieve signup link resend again
  const ResendLinkRegister = (email: string) => {
    main();
    async function main() {
      const variables = {
        resendInput: {
          email: email,
          type: "registration",
        },
      };
      customGraphQLClient.request( resendEmail, variables)
        .then((data) => {
          setAlert("New Email Verification link sent to email", "success");
          // localStorage.setItem("token",JSON.stringify(data?.completeLogin));
        })
        .catch((err) => {
          if (err?.response?.errors) {
            err?.response?.errors?.map((newerro: { message: any }) => {
              setAlert(newerro?.message, "warning");
            });
          } else {
            setAlert("Network Error", "error");
          }
        });
    }
  };

  //if user not receive email for forgotpassword
  const ResendLinkForgot = (email: string) => {
    main();
    async function main() {
      const variables = {
        forgotPassword: {
          email: email,
          
        },
      };
      customGraphQLClient.request( forgerMutation, variables)
        .then((data) => {
          setAlert("New Email Verification link sent to email", "success");
          // localStorage.setItem("token",JSON.stringify(data?.completeLogin));
        })
        .catch((err) => {
          if (err?.response?.errors) {
            err?.response?.errors?.map((newerro: { message: any }) => {
              setAlert(newerro?.message, "warning");
            });
          } else {
            setAlert("Network Error", "error");
          }
        });
    }
  };

  //email enter and the reset link will be sent to mailbox
  const forgotPassword = (email: string, captcha:string) => {
    main();
    async function main() {
      const variables = {
        forgotPassword: {
          email: email,
          captcha: captcha,
        },
      };
      await customGraphQLClient.request( forgerMutation, variables)
        .then((data) => {
          setShowResetLink(true);
          setAlert("Password reset link sent to email", "success");
          // localStorage.setItem("token",JSON.stringify(data?.completeLogin));
        })
        .catch((err) => {
          if (err?.response?.errors) {
            err?.response?.errors?.map((newerro: { message: any }) => {
              if (newerro?.message === "Error: User not found") {
                setAlert(newerro?.message, "warning");
                setShowResetLink(false);
              } else {
                setAlert(newerro?.message, "warning");
                setShowResetLink(true);
              }
            });
          } else {
            setAlert("Network Error", "error");
          }
        });
    }
  };

  //click the resetlink will redirect the user to changepassword page with token param where below query perform
  const recoverPassword = (
    values: { password: string; repassword: string },
    token: string
  ) => {
    main();
    async function main() {
      const variables = {
        resetPassword: {
          newPassword: values.password,
          repeatNewPassword: values.repassword,
          token: token,
        },
      };
      customGraphQLClient.request( resetMutation, variables)
        .then((data) => {
          setAlert("Password reset successfully", "success");
          // localStorage.setItem("token",JSON.stringify(data?.completeLogin));
          history.push("/login");
        })
        .catch((err) => {
          if (err?.response?.errors) {
            err?.response?.errors?.map((newerro: { message: any }) => {
              setAlert(newerro?.message, "warning");
            });
          } else {
            setAlert("Network Error", "error");
          }
        });
    }
  };

  //logout the user
  const Logout = (session: any) => {
    dispatch({
      type: LOGOUT,
    });
    if (session) {
      setAlert("Please login again", "success");
    } else {
      setAlert("Logout Successful", "success");
    }
  };

  //if the token expires this method will be call form the queries 401
  const RefreshTokens = async () => {
    const variables = {
      accessToken: refreshToken,
    };
    await graphQLClient
      .request(REFRESH_TOKEN, variables)
      .then((data) => {
        console.log("tokensuccess", data);
        localStorage.setItem(
          "accessToken",
          JSON.stringify(data.refreshToken.accessToken)
        );
        localStorage.setItem(
          "refreshToken",
          JSON.stringify(data.refreshToken.refreshToken)
        );
        graphQLClient.setHeader('authorization', `Bearer ${data.refreshToken.accessToken}`);
        return true;
      })
      .catch((err) => {
        dispatch({
          type: LOGOUT,
        });
        setAlert("Session Expired - Loggin Out.", "success");
        return false;
      });
  };

  //getting 2fa enabled from user profile section
  const get2faEnableCode = () => {
    main();
    async function main() {
      await graphQLClient
        .request(GET_TWO_FA)
        .then((data) => {
          dispatch({
            type: GET2FACODE,
            payload: data?.get2faEnableCode,
          });
        })
        .catch((err) => {
          // if(err.response.errors[0].extensions.response.statusCode === 401){
          //   RefreshTokens();
          // }else{
          //   setAlert("Something went wrong", "error");
          // }
        });
    }
  };

  //perform mutation to verify the 2fa enabled
  const enable2FA = (twoFAcode: any) => {
    main();
    async function main() {

      const variables = {
        enable2faInput: {
          twoFactorAuthenticationCode: twoFAcode,
        },
      };

      await graphQLClient
        .request(ENABLE_TWOFA, variables)
        .then((data) => {
          setAlert("2FA Authentication Enabled", "success");
          getProfile();
        })
        .catch((err) => {
          if (
            err?.response?.errors[0]?.extensions?.response?.statusCode === 401
          ) {
            RefreshTokens();
          } else {
            if (err?.response?.errors) {
              err?.response?.errors?.map((newerro: { message: any }) => {
                setAlert(newerro?.message, "error");
              });
            } else {
              setAlert("Something went wrong while enabling 2FA.", "error");
            }
          }
        });
    }
  };

  //if user wants to disable the 2fa
  const disable2FA = (twoFAcode: any) => {
    main();
    async function main() {
      const variables = {
        enable2faInput: {
          twoFactorAuthenticationCode: twoFAcode,
        },
      };
      await graphQLClient
        .request(DISABLE_TWOFA, variables)
        .then((data) => {
          setAlert("2FA Authentication Disabled", "success");
          getProfile();
        })
        .catch((err) => {
          if (
            err?.response?.errors[0]?.extensions?.response?.statusCode === 401
          ) {
            RefreshTokens();
          } else {
            if (err?.response?.errors) {
              err?.response?.errors?.map((newerro: { message: any }) => {
                setAlert(newerro?.message, "error");
              });
            } else {
              setAlert("Something went wrong while disabling 2FA.", "error");
            }
          }
        });
    }
  };

  //once login this query perform on second step of verification code
  const verify2FA = (twoFAcode: any) => {
    return new Promise((resolve, reject) => {
      const twoFAtoken = localStorage.getItem("twoFaToken");
      main();
      async function main() {
        const variables = {
          verify2faInput: {
            token: twoFAtoken,
            twoFactorAuthenticationCode: twoFAcode,
          },
        };
        await customGraphQLClient.request(VERIFY_TWOFA, variables)
          .then((data) => {
            graphQLClient.setHeader('authorization', `Bearer ${data?.verify2fa.accessToken}`)
            dispatch({
              type: LOGIN,
              payload: data?.verify2fa,
            });
            setAlert("You are logged in", "success");
            resolve(true);
            history.push("/deals");
          })
          .catch((err) => {
            if (err?.response?.errors) {
              err?.response?.errors?.map((newerro: { message: any }) => {
                setAlert(newerro?.message, "error");
              });
            } else {
              setAlert("Something went wrong with 2FA verification.", "error");
            }
            reject();
          });
      }
    })
  };

  //get the user profile details
  const getProfile = () => {
    main();
    async function main() {
      await graphQLClient
        .request(GET_PROFILE)
        .then((data) => {
          dispatch({
            type: GETPROFILE,
            payload: data?.returnUserProfile,
          });
        })
        .catch(async (err) => {
          if (
            err?.response?.errors[0]?.extensions?.response?.statusCode === 401
          ) {
            RefreshTokens();
          } else {
            setAlert("Something went wrong while fetching user profile.", "error");
          }
        });
    }
  };

  return (
    <AuthContext.Provider
      value={{
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuth: state.isAuthenticated,
        userobj: state.userobj,
        isLoading: state.isLoading,
        getProfileData: state.getProfileData,
        secretToken: state.secretToken,
        otpAuthUrl: state.otpAuthUrl,
        sendLoginDispatch,
        Login,
        GoogleLogin,
        Logout,
        SignUpService,
        ResendLinkRegister,
        forgotPassword,
        recoverPassword,
        ResendLinkForgot,
        getProfile,
        RefreshTokens,
        get2faEnableCode,
        enable2FA,
        disable2FA,
        verify2FA,
        showresetlink: showresetlink,
        setShowResetLink,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default withRouter(AuthState);
